var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 11",
    fill: "#2E3941",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6404 0.723039C11.0569 1.07071 11.121 1.70042 10.7835 2.12954L4.49269 10.1295C4.3186 10.3509 4.0611 10.4853 3.78486 10.4989C3.50862 10.5125 3.23987 10.404 3.04609 10.2007L0.278123 7.29701C-0.0974839 6.90299 -0.0919477 6.26985 0.290489 5.88286C0.672925 5.49587 1.28744 5.50158 1.66305 5.8956L3.669 7.99992L9.27524 0.870523C9.61268 0.441403 10.2239 0.375372 10.6404 0.723039Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheckmark);
export default __webpack_public_path__ + "static/media/checkbox-checkmark.18d38e59583cd7c01b2b9458d6ad6988.svg";
export { ForwardRef as ReactComponent };